import {Button} from 'antd';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Layout, {Main} from '../../components/Layout';

class ListingInfos extends React.Component<{}, {}> {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Listing Infos</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>Listing Infos</CardHeader>
              <CardBody>
                <a
                  href="https://airtable.com/tbllc9uYWL4g0BKQV/viwahWDSUUjDfQbr8?blocks=hide"
                  target="_blank"
                >
                  <Button type="primary">Edit Listing Infos</Button>
                </a>
                <iframe
                  className="airtable-embed"
                  src="https://airtable.com/embed/shrH6c1ilLIO3bQQo?backgroundColor=green&viewControls=on"
                  frameBorder="0"
                  width="100%"
                  height="533"
                  style={{
                    background: 'transparent',
                    border: '1px solid #ccc;'
                  }}
                />
              </CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }
}

export default ListingInfos;



// WEBPACK FOOTER //
// ./src/pages/ListingInfos/ListingInfos.tsx